import { render, staticRenderFns } from "./DpstHstryApp.vue?vue&type=template&id=4c85f80a&"
import script from "./DpstHstryApp.vue?vue&type=script&lang=js&"
export * from "./DpstHstryApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports